export default __webpack_public_path__ + "static/media/slidecompus2.004692ef.png";